import React, { useRef, useState, useEffect } from 'react';

const useStateRef = initialValue => {
    const [value, setValue] = useState(initialValue);

    const ref = useRef(value);

    useEffect(() => {
        console.log('updating value', value);
        ref.current = value;
        console.log('updated', ref.current);
    }, [value]);

    return [value, setValue, ref];
};

export default useStateRef;
